// ======================================================================
// Forge Lite | hello@hashandsalt.com
// ======================================================================

// require any further scripts here ie:
// require('npmpackagename');
// require('./mylocalfile.js');
"use strict";

require("./common-vanilla-scripts.js");
require("./arrive.min.js");

/********************
 * FullCalendar.js
 ********************/

import {Calendar} from "@fullcalendar/core";
import rrulePlugin from "@fullcalendar/rrule";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";

const eventUrl = "/calendar.json";
var allEvents = []; // set global

/*****
 * get original data for consistent filtering
 * concept from https://stackoverflow.com/a/77905874/4504073
 * ajax from https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
 *****/
async function getEvents() {
  try {
    const response = await fetch(eventUrl);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    // get json asynchronously
    allEvents = await response.json();
    // save all events and send to caller
    return allEvents;
  } catch (error) {
    console.error(error.message);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // get calendar div
  let calendarEl = document.getElementById("calendar");

  // determine view
  let initialView = "listMonth";
  let headerToolbarRight = "";
  let mql = window.matchMedia("(width <= 768px)");
  // if mobile view
  if (mql.matches) {
    // console.log("mobile screen");
  } else {
    // console.log("desktop screen");
    initialView = "dayGridMonth";
    // headerToolbarRight = "dayGridMonth,timeGridWeek,listWeek";
    headerToolbarRight = "dayGridMonth,timeGridWeek,listMonth,listYear";
  }

  if (calendarEl) {
    let calendar = new Calendar(calendarEl, {
      // aspectRatio: 1.05, // prevent scrollbar
      plugins: [rrulePlugin, dayGridPlugin, timeGridPlugin, listPlugin],
      initialView: initialView,
      headerToolbar: {
        left: "prev,next today",
        center: "title",
        right: headerToolbarRight,
      },
      buttonText: {
        listYear: "year",
      },
      // aspectRatio: 1,
      // expandRows: false,

      events: eventUrl,
    });

    // show the calendar
    calendar.render();

    /****
     * Calendar Filter
     *****/
    // get all events for filtering
    allEvents = getEvents();

    // get selector
    let filterSelect = document.getElementById("filterSelect");
    // get original data since FullCalendar doesn't seem to save this info

    // handle change
    filterSelect.addEventListener("change", function () {
      let selectedFilter = filterSelect.value;
      // console.log("selectedFilter", selectedFilter);

      // only collect filtered events (custom data attributes always moved to extendedProps)
      // assumeed after ajax events return
      let filteredEvents = allEvents.filter(function (event) {
        // console.log("event.dataFilter", event.dataFilter);
        return selectedFilter === "all" || event.dataFilter === selectedFilter;
      });

      // console.log("filteredEvents", filteredEvents);

      // redraw calendar
      calendar.setOption("events", filteredEvents);
    });
  }
});

// ======================================================================
// Modules
// ======================================================================

/********************
 * External links to new tab
 * from https://forum.getkirby.com/t/open-link-in-new-tab-button-for-non-coders/3151/15?u=lukehatfield
 * and https://stackoverflow.com/a/6823034/4504073
 ********************/
let checkLinks = function (links) {
  let len = links.length;
  for (let i = 0; i < len; i++) {
    let linkHost = links[i].host;
    // console.log('found a link!', linkHost);

    // don't do internal links or anchor tags...
    // if ((linkHost !== window.location.host) && (linkHost != '') && (linkHost != 'www.nantucketarts.org') && (linkHost != 'shop.nantucketarts.org') && (linkHost != 'nantucket-arts.myshopify.com') && (linkHost != 'nantucketarts.loc')) {
    if (linkHost !== window.location.host && linkHost != "" && linkHost != "careers.theadclub.org") {
      links[i].target = "_blank";
    }
  }
};
// init
let links = document.getElementsByTagName("a");
checkLinks(links);

// require any further scripts here ie:
import Glide from "@glidejs/glide";

// global
site.openNavOffset;

// check screenwidth, from https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia
site.isMedium = window.matchMedia("(min-width: 768px)");

document.addEventListener("DOMContentLoaded", function () {
  /*****
   * Search Bar
   *****/
  let searchIcons = document.querySelectorAll(".search-svg");
  if (searchIcons.length > 0) {
    searchIcons.forEach(function (elem, index) {
      elem.addEventListener("click", function (event) {
        // remove onscroll event so doesn't close menu right away
        document.onscroll = false;

        document.body.classList.toggle("show-search-bar");

        // move focus
        elem.closest(".core").querySelector(".search-input").focus();
      });
    });
  }

  /**
   * Announcement Bar
   **/

  /*
   * Newsletter placeholder on Constant Contact inline form
   * uses arrive.js for simplicity, from https://github.com/uzairfarooq/arrive
   */

  let ccWrapper = document.getElementById("cc-await-form-arrival");

  // this will attach arrive event to all elements in the NodeList
  if (ccWrapper) {
    ccWrapper.arrive("#ctct_form_0", function () {
      document.getElementById("email_address_field_0").addEventListener("input", function () {
        this.classList.add("hide-placeholder");
      });
    });
  }

  /*
   * Sidebar scroll to reveal popdown
   */
  let sidebarLinks = document.querySelectorAll(".sidebar-link");
  // console.log('sidebarLinks', sidebarLinks);
  if (sidebarLinks.length > 0) {
    sidebarLinks.forEach(function (elem, index) {
      elem.addEventListener("click", function (event) {
        // get clicked target and remove leading #
        let hash = event.target.hash.replace("#", "");

        // get destination
        let destination = document.getElementById(hash);

        // some sidebar links have no interior anchor
        if (destination) {
          console.log("destination", destination);

          // get popdown and click it
          let popdown = destination.nextElementSibling.querySelector(".popdown-section-link");

          // click it
          if (popdown) {
            popdown.click();
          }
        }
      });
    });
  }

  /*
   * Secondary links reveal
   * multiple b/c desktop & mobile headers
   */
  let parentLinks = document.querySelectorAll(".parent-link");
  if (parentLinks.length > 0) {
    parentLinks.forEach(function (elem, index) {
      elem.addEventListener("click", function (event) {
        // don't go default
        event.preventDefault();

        // hide if already open
        if (elem.classList.contains("show-secondary-nav-sibling")) {
          elem.classList.remove("show-secondary-nav-sibling");
          elem.closest(".nav-wrapper").classList.remove("show-secondary-nav-child");
        } else {
          // remove any open menus
          parentLinks.forEach(function (elem, index) {
            elem.classList.remove("show-secondary-nav-sibling");
          });

          // show closest links
          elem.classList.add("show-secondary-nav-sibling");
          // show or hide on parent so can gray out links
          elem.closest(".nav-wrapper").classList.add("show-secondary-nav-child");
        }
      });
    });
  }

  /**
   * Create an intersection observer
   * from https://gomakethings.com/options-settings-and-approaches-with-the-vanilla-js-intersection-observer-api/
   * @param  {Node}     elem     The element to observe
   * @param  {Function} callback The callback function to run
   * @param  {Object}   options  The options, if any
   */
  function createIntersectionObserver(elem, callback, options) {
    let observer = new IntersectionObserver(callback, options || {});
    observer.observe(elem);
    return observer;
  }

  /**
   * Do this when entering or leaving viewport
   * @param  {Array} entries The intersecting elements
   */
  // save previous position so can tell direction
  let previousY = 0;

  function animateHeader(entries, obs) {
    let [entry] = entries;
    if (entry.isIntersecting) {
      document.body.classList.remove("show-smaller-nav");
    } else {
      document.body.classList.add("show-smaller-nav");
    }
  }

  // exceptions
  let prepThreshold;
  prepThreshold = 0.2;

  // Setup our observer options
  let animationOptions = {
    rootMargin: "0px", // viewport bottom offset
    threshold: 0.01, // if just a little bit of the topper image is showing, don't show smaller nav
  };

  // if(document.querySelector('.page-topper-section')) {
  let navbarJs = document.getElementById("navbar-js");
  if (navbarJs) {
    // turn off smaller-header
    createIntersectionObserver(navbarJs, animateHeader, animationOptions);
  }

  /*****
   * sidebar mobile
   *****/
  let sidebarSelect = document.getElementById("sidebar-select");
  if (sidebarSelect && getComputedStyle(sidebarSelect).display != "none") {
    sidebarSelect.addEventListener("input", function (event) {
      console.log("event.target.value", event.target.value);
      let hash = event.target.value;
      if (hash) {
        let element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView();
          // else must be external link
        } else {
          // go there
          location = hash;
        }
      }
    });
  }

  /*
   * Classes page material reveal
   */
  let materialsButton = document.getElementById("materials-button");
  if (materialsButton) {
    // prep by showing partial
    let partialMaterials = document.getElementById("partial-course-materials");
    partialMaterials.style.display = "block";
    // prep by hiding full
    let fullMaterials = document.getElementById("full-course-materials");
    fullMaterials.style.display = "none";
  }

  /*
   * Content Reveal
   */

  // event page content reveal
  // check for sidebar tabs
  let moreLists = document.querySelectorAll(".more-text-link");
  moreLists.forEach(function (moreLink) {
    console.log("moreLink", moreLink);
    moreLink.addEventListener("click", function (event) {
      event.preventDefault(); // dont go anywhere

      // show text and change svg icon to minus
      this.closest(".more-link-wrapper").classList.toggle("show-more-text");
    });
  });

  // any page content reveal
  let popdownList = document.querySelectorAll(".popdown-section-link");
  if (popdownList.length) {
    popdownList.forEach(function (popdownLink) {
      popdownLink.addEventListener("click", function (event) {
        // console.log("clicked popdown link");
        event.preventDefault(); // dont go anywhere

        this.classList.toggle("is-open");
      });
    });
  }

  /*
   * People reveal
   */

  // check for sidebar tabs
  let peopleList = document.querySelectorAll(".popdown-list");
  if (peopleList.length) {
    // count how many showing in one line so can place dropdown appropriately
    let memberColumns;

    peopleList.forEach(function (peopleList) {
      // get all people
      let people = peopleList.querySelectorAll(".popdown-item");

      // for each person...
      people.forEach(function (person, index) {
        // listen for clicks on sidebar tabs
        person.addEventListener("click", function (event) {
          // stop if no data or if trying to close a large list
          if (person.classList.contains("is-active") || event.target.matches(".minus-text")) {
            event.preventDefault();
            let closestClose = person.closest("section").querySelector(".person-dropdown-close-wrapper");
            if (closestClose) {
              // close popdown if open
              closestClose.click();
            }
            return;
          }

          // larger list on membership page
          if (this.closest("section") && this.closest("body").classList.contains("membership-page")) {
            if (site.isMobile) {
              memberColumns = 2;
            } else {
              memberColumns = 6;
            }
            // connector
          } else if (this.closest("section") && this.closest("body").classList.contains("connector-page")) {
            if (site.isMobile) {
              memberColumns = 2;
            } else {
              memberColumns = 4;
            }
          } else if (this.closest("section") && (this.closest("section").classList.contains("our-honorees-section") || this.closest("section").classList.contains("speakers-section") || this.classList.contains("entry-item"))) {
            if (site.isMobile) {
              memberColumns = 2;
            } else {
              memberColumns = 3;
            }

            // figure out how many in each row
          } else if (this.closest("section") && this.closest("section").classList.contains("popdown-grid-section")) {
            if (site.isMobile) {
              memberColumns = 2;
            } else {
              memberColumns = 4;
            }

            // vertical list
          } else if (this.closest("section") && (this.closest("section").classList.contains("popdown-small-list-section") || this.closest("section").classList.contains("popdown-large-list-section"))) {
            memberColumns = 1;

            // other lists
          } else {
            if (site.isMobile) {
              memberColumns = 1;
            } else {
              memberColumns = 3;
            }
          }

          // update hash if podcast for sharing
          if (this.classList.contains("podcast-item")) {
            // from https://stackoverflow.com/a/14690177/4504073
            if (history.pushState) {
              history.pushState(null, null, "#episode-" + this.id);
            } else {
              location.hash = "#episode-" + this.id;
            }
          }

          // update hash if cmo breakfast for linking
          if (this.classList.contains("breakfast-item")) {
            // from https://stackoverflow.com/a/14690177/4504073
            if (history.pushState) {
              history.pushState(null, null, "#" + this.id);
            } else {
              location.hash = "#" + this.id;
            }
          }

          // activate dropdown pointer
          people.forEach(function (person, index) {
            // clear out old pointers
            person.classList.remove("is-active");
          });
          person.classList.add("is-active");

          if (person.dataset.info) {
            let memberDetails = JSON.parse(person.dataset.info);

            // console.log("memberDetails", memberDetails);

            // if have anything to show
            if (memberDetails.allowClick) {
              // get relative popup box
              let thisGroup = person.closest(".popdown-list");

              // unless on content hub page
              if (thisGroup.classList.contains("hub-list")) {
                // console.log("found .hub-list");
                thisGroup = document.getElementById("popover-box");
                document.body.classList.add("hub-popover-open");
              }

              let thesePeople = thisGroup.querySelectorAll(".popdown-item");
              // convert to array so can filter to find clicked member
              let thesePeopleArray = [].slice.call(thesePeople);

              let peopleDropdownBox = thisGroup.querySelector(".person-dropdown-box");
              let peopleDropdownPicture = peopleDropdownBox.querySelector(".person-dropdown-picture-wrapper");
              let peopleDropdownLeft = peopleDropdownBox.querySelector(".person-dropdown-left");
              let peopleDropdownRight = peopleDropdownBox.querySelector(".person-dropdown-right");
              let popdownEmail = peopleDropdownBox.querySelector(".person-dropdown-email");
              let popdownUrls = peopleDropdownBox.querySelector(".person-dropdown-urls");
              let popdownSocial = peopleDropdownBox.querySelector(".popdown-social");
              let peopleDropdownSidebar = peopleDropdownBox.querySelector(".person-dropdown-sidebar");

              // get index of current group only

              let thisIndex = thesePeopleArray.indexOf(person);
              let nonZeroIndex = thisIndex + 1;

              // check if on connector page, if so use grid row method since popdown messes up order
              // for freelancers
              if (document.body.matches("#connector-page")) {
                // get person row
                let personRow = parseInt(person.dataset.row); // make sure an int before do math on it
                console.log("personRow", personRow);
                if (personRow) {
                  peopleDropdownBox.style.gridRow = personRow + 1;
                }

                // check if already in last block in row (remainder will be 0)
              } else if (nonZeroIndex % memberColumns == 0) {
                // set this index
                peopleDropdownBox.style.order = nonZeroIndex - 1;
              } else {
                // get index of last item in the row by taking 6 inverse of modulo
                let distanceToLastItemInRow = memberColumns - (nonZeroIndex % memberColumns);
                // get last element in row
                let lastElementInRow = thesePeopleArray[thisIndex + distanceToLastItemInRow];

                // last row element exists, but dont need undefined b/c know it exists from https://stackoverflow.com/a/5515349/4504073
                if (lastElementInRow) {
                  // get index of last element in the row and set it
                  peopleDropdownBox.style.order = [].indexOf.call(thesePeopleArray, lastElementInRow);

                  // if no last element b/c incomplete last row, put at end
                } else {
                  peopleDropdownBox.style.order = 520; // more than ever before
                }
              }

              thisGroup.classList.add("show-person");

              // loop through left side
              peopleDropdownLeft.childNodes.forEach(function (elem) {
                let elemID = elem.id;

                // possibly multiple elements in podcast left
                if (elemID == "guests" && memberDetails["guests"]) {
                  let guestsHTML = ""; // string to hold html
                  memberDetails[elemID].forEach(function (guest) {
                    guestsHTML += '<div class="podcast-guest">' + '<div class="guest-name">' + guest.name + "</div>" + '<div class="guest-position">' + guest.position + "</div>" + "</div>";
                  });

                  // replace with wrapped div and content
                  // from https://gomakethings.com/how-to-replace-an-element-and-its-content-using-vanilla-js/
                  elem.outerHTML = '<div id="guests" class="podcast-guests">' + guestsHTML + "</div>";

                  // sharing
                } else if (elemID == "sharing") {
                  // swap sharing links
                  elem.querySelector("#facebook-link").setAttribute("href", memberDetails[elemID]["facebook"]);
                  elem.querySelector("#twitter-link").setAttribute("href", memberDetails[elemID]["twitter"]);
                  elem.querySelector("#linkedin-link").setAttribute("href", memberDetails[elemID]["linkedin"]);

                  // else simple swap
                } else if (typeof memberDetails[elemID] !== "undefined" && memberDetails[elemID] != null) {
                  elem.innerHTML = memberDetails[elemID];
                  elem.classList.remove("no-details");

                  // else blank
                } else if (elem.nodeType != Node.TEXT_NODE && elem.nodeType != Node.COMMENT_NODE) {
                  elem.classList.add("no-details");
                }
              });

              // loop through right side
              peopleDropdownRight.childNodes.forEach(function (elem) {
                let elemID = elem.id;
                // deal with tags first, for freelancers
                if (elemID == "tags") {
                  // clear out old el
                  elem.textContent = "";

                  // loop through data
                  console.log(memberDetails[elemID]);
                  for (const [key, value] of Object.entries(memberDetails[elemID])) {
                    console.log(`${key}: ${value}`);
                    // remove dashes
                    let title = key.replaceAll("-", " ");

                    // make a category div
                    let div = document.createElement("div");
                    // add class
                    div.setAttribute("class", "tag-category-wrapper");
                    // make a title Span
                    let titleSpan = document.createElement("span");
                    // add class
                    titleSpan.setAttribute("class", "tag-category-title");
                    // add content
                    titleSpan.innerHTML = title + ": ";
                    // one one to the other
                    div.appendChild(titleSpan);

                    // add tags
                    let tags = "";
                    for (const [key, value] of Object.entries(value)) {
                      // console.log("value: ", value);
                      tags = tags + value + " / ";
                    }
                    // remove last comma
                    tags = tags.substring(0, tags.length - 2);

                    let tagsSpan = document.createElement("span");
                    // add content
                    tagsSpan.innerHTML = tags;
                    // add tags to the parent
                    div.appendChild(tagsSpan);

                    // add to popdown
                    elem.appendChild(div);
                  }

                  // set grid row to prevent spillage after sorting
                } else if (memberDetails[elemID]) {
                  elem.innerHTML = memberDetails[elemID];
                  elem.classList.remove("no-details");
                  // hide player if nothing to play
                } else if (elemID == "soundcloud" || elemID == "libsyn") {
                  elem.classList.add("no-details");
                  elem.innerHTML = ""; // stop player from playing
                  // hide text node if nothing to show
                } else if (elem.nodeType != Node.TEXT_NODE && elem.nodeType != Node.COMMENT_NODE) {
                  elem.classList.add("no-details");
                }
              });

              // loop through sidebar
              if (peopleDropdownSidebar) {
                peopleDropdownSidebar.childNodes.forEach(function (elem) {
                  let elemID = elem.id;
                  // if not null
                  if (memberDetails[elemID]) {
                    elem.innerHTML = memberDetails[elemID];
                    elem.classList.remove("no-details");

                    // add class if no details and not a text node
                  } else if (elem.nodeType != Node.TEXT_NODE && elem.nodeType != Node.COMMENT_NODE) {
                    // hide element
                    elem.classList.add("no-details");
                  }
                });
              }

              // loop through social media
              if (popdownSocial) {
                console.log("popdown social exists");
                popdownSocial.childNodes.forEach(function (elem) {
                  let elemID = elem.id;
                  // if not null
                  if (memberDetails["sharing"] && memberDetails["sharing"][elemID]) {
                    // update link
                    elem.querySelector("a").href = memberDetails["sharing"][elemID];
                    elem.classList.remove("no-details");

                    // add class if no details and not a text node
                  } else if (elem.nodeType != Node.TEXT_NODE && elem.nodeType != Node.COMMENT_NODE) {
                    // hide element
                    elem.classList.add("no-details");
                  }
                });
              }

              // freelancer email
              if (popdownEmail) {
                popdownEmail.innerHTML = memberDetails["email"];
              }

              if (popdownUrls) {
                // loop through urls
                let urlIndex = 0;
                let linksArray = Array.from(popdownUrls.children); // from https://stackoverflow.com/a/15094927/4504073
                linksArray.forEach(function (elem, index) {
                  // let elemID = elem.id;
                  // console.log("elem", elem);
                  // if not null
                  if (memberDetails["urls"][index]) {
                    // console.log("memberDetails[urls][index]", memberDetails["urls"][index]);
                    // update link
                    elem.href = memberDetails["urls"][index]["url"];
                    // update text
                    elem.querySelector("span").innerHTML = memberDetails["urls"][index]["text"];
                    // show it
                    elem.classList.remove("no-details");

                    // add class if no details and not a text node
                  } else {
                    // hide element
                    elem.classList.add("no-details");
                  }
                });
              }

              // wrap any iframes in iframe wrapper for responsiveness
              if (!document.getElementById("podcasts-page")) {
                let iframes = peopleDropdownRight.querySelectorAll("iframe");
                iframes.forEach(function (iframe) {
                  // don't do for vimeo on hub video b/c using kirby responsive vimeo helper
                  // console.log("wrap this with iframe-wrapper");
                  // make new wrapper div with class name
                  let iframeWrapper = document.createElement("div");
                  iframeWrapper.classList.add("iframe-wrapper");
                  // first replace existing iframe with wrapper div
                  // replace existing element with new one, from https://www.javascripttutorial.net/dom/manipulating/replace-a-dom-element/
                  iframe.parentNode.replaceChild(iframeWrapper, iframe);
                  // bring original iframe back now
                  iframeWrapper.appendChild(iframe);
                });
              }

              // move browser to top of selected podcast
              let anchor = this.querySelector(".anchor-link");
              if (anchor) {
                anchor.scrollIntoView({behavior: "instant"});
              }
            } else {
              console.log("block click on this item");
              // close info box
              let closestClose = person.closest("section").querySelector(".person-dropdown-close-wrapper");
              if (closestClose) {
                // close popdown if open
                closestClose.click();
              }
            }
          } else if (person.classList.contains("locked-item")) {
            let popoverBox = document.getElementById("popover-box");
            popoverBox.classList.add("show-person", "show-member-login");
            document.body.classList.add("hub-popover-open");

            // focus on email input
            let emailInput = document.querySelector("input#email");
            emailInput.focus();
          }

          // add target blank to any new links
          // let thesePeopleList = this.closest('.popdown-list').querySelector('.popdown-box').getElementsByTagName('a');
          checkLinks(links);
        });
      });
    });

    // close button
    let memberCloseButtons = document.querySelectorAll(".person-dropdown-close-wrapper, .minus-text");

    memberCloseButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        closeInfo(this); // encapsulate function so escape key works too
      });
    });
  }

  // close modal, popover, or popdown?
  function closeInfo(button) {
    // try to stop podcast from playing before destroying
    let libsyn = document.querySelector(".person-dropdown-libsyn");
    if (libsyn) {
      libsyn.innerHTML = "";
    }

    // remove body lock
    if (document.body.classList.contains("hub-popover-open")) {
      document.body.classList.remove("hub-popover-open");
      // remove all active states on page if doing popover
      document.querySelectorAll(".popdown-item").forEach(function (person, index) {
        person.classList.remove("is-active");
      });
    }

    let thesePeopleList = button.closest(".popdown-list");
    if (thesePeopleList) {
      thesePeopleList.classList.remove("show-person");
      thesePeopleList.classList.remove("show-member-login");

      // stop popup video from playing
      let peopleDropdownBox = thesePeopleList.querySelector(".person-dropdown-box");
      let peopleDropdownRight = peopleDropdownBox.querySelector(".person-dropdown-right");
      let iframes = peopleDropdownRight.querySelectorAll("iframe");
      iframes.forEach(function (iframe) {
        iframe.src = "";
      });

      // remove .is-active from person-item
      let thesePeople = thesePeopleList.querySelectorAll(".popdown-item");
      if (thesePeople) {
        thesePeople.forEach(function (person, index) {
          person.classList.remove("is-active");
        });
      }
    }
  }

  /*****
   * content member only popover
   *****/
  let videoLists = document.querySelectorAll(".video-list");
  if (videoLists.length) {
    videoLists.forEach(function (videoList) {
      // get all people
      let videoItems = videoList.querySelectorAll(".video-item");
      videoItems.forEach(function (videoItem, index) {
        videoItem.addEventListener("click", function (event) {
          // console.log("clicked video link");
          event.preventDefault(); // dont go anywhere
          if (videoItem.classList.contains("locked-item")) {
            let popoverBox = document.getElementById("popover-box");
            popoverBox.classList.add("show-person", "show-member-login");
            document.body.classList.add("hub-popover-open");
            // // focus on email input
            // let emailInput = document.querySelector("input#email");
            // emailInput.focus();
          }
        });
      });
    });
  }

  /*
   * Sidebar Tabs
   */

  let showContent = function (elem, index, sidebarContent) {
    // console.log('clicked me', index);
    // hide all content in preparation for revealing desired content
    sidebarContent.forEach(function (content) {
      content.style.display = "none";
    });

    // then open corresponding tab on right
    sidebarContent[index].style.display = "block";

    elem.classList.add("is-active");
  };

  // mobile program tabs select
  let tabSelects = document.querySelectorAll(".tabs-select");
  // go through each select
  tabSelects.forEach(function (tabSelect) {
    let sidebarContent = tabSelect.closest(".tabs-wrapper").querySelectorAll(".tabs-main-list-item");

    if (tabSelect) {
      tabSelect.addEventListener("input", function (event) {
        let index = event.target.value;

        showContent(this.closest(".tabs-wrapper"), index, sidebarContent);
      });
    }
  });

  // check for sidebar tabs
  let sidebarTabsWrapper = document.querySelectorAll(".tabs-wrapper");

  sidebarTabsWrapper.forEach(function (sidebarTabsWrapper) {
    // get tabs on left
    let sidebarTabs = sidebarTabsWrapper.querySelectorAll(".tabs-link");
    // get content on right
    let sidebarContent = sidebarTabsWrapper.querySelectorAll(".tabs-main-list-item");

    sidebarTabs.forEach(function (sidebarTab, index) {
      sidebarTab.addEventListener("click", function (event) {
        // reset visible minilinks
        sidebarTabs.forEach(function (tab) {
          tab.classList.remove("is-active");
        });

        // listen for clicks on sidebar tabs
        showContent(this, index, sidebarContent);

        // scroll to top on desktop
        // let anchor = elem.closest('.tabs-wrapper').querySelector('.tabs-main').querySelector('.anchor-link');
        let anchor = this.closest("section").querySelector(".anchor-link");
        anchor.scrollIntoView({behavior: "instant"});
      });
    });
  });

  /*****
   * wrap adjacent color boxes on media auction page together
   *****/
  let colorboxes = document.querySelectorAll(".color-box-section");
  colorboxes.forEach(function (colorboxSection, index) {
    // if no colorbox before, but one after, start wrapper div
    if (colorboxSection.previousElementSibling.classList.contains("color-box-section")) {
      let previousElementSibling = colorboxSection.previousElementSibling;

      // replace with wrapped div and content
      // from https://gomakethings.com/how-to-replace-an-element-and-its-content-using-vanilla-js/
      colorboxSection.outerHTML = '<div class="colorbox-wrapper">' + '<div class="core">' + '<div class="inner-core">' + colorboxSection.previousElementSibling.outerHTML + colorboxSection.outerHTML + "</div>" + "</div>" + "</div>";

      // remove previous element sibling
      previousElementSibling.outerHTML = "";
    }
  });

  /*****
   * get hash for podcast sharing
   *****/
  if (document.body.matches(".podcasts-page")) {
    let hash = window.location.hash;
    let podcastID = hash.split("-").pop();
    // open that podcast
    let podcast = document.getElementById(podcastID);
    if (podcast) {
      podcast.click();
    }

    // else if cmo breakfast page
  } else if (document.body.matches(".cmo-breakfast-page")) {
    let hash = window.location.hash;
    let breakfastID = hash.replace("#", "");
    // open that breakfast
    let breakfast = document.getElementById(breakfastID);
    if (breakfast) {
      breakfast.click();
    }

    // activate anchors on other pages
  } else {
    let hash = window.location.hash.replace("#", "");
    // open that section
    if (hash) {
      let anchor = document.getElementById(hash);
      if (anchor) {
        if (anchor.nextElementSibling) {
          let clickable = anchor.nextElementSibling.querySelector(".popdown-section-link");
          if (clickable) {
            clickable.click();
          }
        }
      }
    }
  }

  /**
   * Global Event Listener
   **/
  document.addEventListener(
    "click",
    function (event) {
      /*
       * Menu
       */
      if (event.target.matches("#menu-button-wrapper") || event.target.parentElement.matches("#menu-button-wrapper")) {
        // Run your code to open a modal
        document.body.classList.add("menu-is-open");
        site.openNavOffset = window.pageYOffset;

        // close menu if any scroll happens
        document.onscroll = function () {
          // close menu
          document.body.classList.remove("menu-is-open");
          // remove scroll listener
          document.onscroll = false;
        };
      }
      if (event.target.matches("#close-icon") || event.target.closest("svg") || !event.target.closest(".smaller-header-inner")) {
        if (!event.target.closest("#dropdown-search-svg") && !event.target.closest(".search-form")) {
          document.body.classList.remove("menu-is-open");
        }
      }
    },
    false
  );

  /**
   * Keypresses
   * from https://stackoverflow.com/a/64446856/4504073
   * just won't work if click on the iframe video to play b/c focus is trapped?
   **/
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      console.log("event.key", event.key);
      let memberCloseButtons = document.querySelectorAll(".person-dropdown-close-wrapper, .minus-text");

      memberCloseButtons.forEach(function (button) {
        closeInfo(button); // encapsulate function so escape key works too
      });
    }
  });

  /**
   * Process slider
   **/

  // if(!site.isMobile && document.getElementById('home-page')) {
  if (document.querySelector(".gallery-section")) {
    // console.log('gallery present');
    let galleryPeekSpacer = document.getElementById("gallery-peek-spacer");
    let galleryPeekPx = galleryPeekSpacer.offsetWidth;

    // desktop, greater than 1820
    if (site.screenWidth > site.breakMd) {
      // take full site width, minus core, divide by 2 to get 1 side, add 2 columns
      galleryPeekPx = (site.screenWidth - 1560) / 2 + 130 * 2;
    }

    let galleryGutterSpacer = document.getElementById("gallery-gutter-spacer");
    let galleryGutterPx = galleryGutterSpacer.offsetWidth;

    // store array of slides so can add custom classes

    // init glide for each gallery on page
    let galleryGliders = document.querySelectorAll(".glide");
    galleryGliders.forEach(function (glider, index) {
      let galleryGlide = new Glide(glider, {
        type: "carousel",
        // autoplay: 4000,
        animationTimingFunc: "ease",
        animationDuration: 600,
        gap: galleryGutterPx,
        hoverpause: false,
        peek: {before: galleryPeekPx, after: galleryPeekPx},
      });

      // activate
      galleryGlide.mount();
    });
  }

  /*****
   * blog article callouts
   *****/
  let pullquoteGliders = document.querySelectorAll(".pullquote-glider");
  if (pullquoteGliders) {
    // init glide for each gallery on page
    pullquoteGliders.forEach(function (glider, index) {
      let numSlides = glider.querySelectorAll(".pullquote-item").length;
      console.log("numSlides", numSlides);

      // only make into a slider if more than one slide
      if (numSlides > 1) {
        let pullquoteGlide = new Glide(glider, {
          type: "carousel",
          animationTimingFunc: "ease",
          // animationDuration: 600,
          hoverpause: false,
        });

        // activate
        pullquoteGlide.mount();
      }
    });
  }

  /**
   * Create a resize observer
   * based on https://gomakethings.com/options-settings-and-approaches-with-the-vanilla-js-intersection-observer-api/
   * @param  {Node}     elem     The element to observe
   * @param  {Function} callback The callback function to run
   * @param  {Object}   options  The options, if any
   */
  function createResizeObserver(elem, callback, options) {
    let observer = new ResizeObserver(callback, options || {});
    observer.observe(elem);
    return observer;
  }

  /**
   * Do this when viewport changes
   * @param  {Array} entries The resized elements
   */
  function roCallback(entries, obs) {
    let [entry] = entries;
    // recount and label freelancer rows
    if (document.body.matches("#connector-page")) {
      setRows();
    }
  }

  // Home page category images
  if (document.getElementById("home-page") || document.getElementById("connector-page")) {
    let body = document.body;
    // createResizeObserver(body, roCallback, roOptions);
    createResizeObserver(body, roCallback);
  }

  /*
   * Animated SVG line
   * from https://stackoverflow.com/a/56705687/4504073
   */

  // // no mobile and only on home page
  // if (document.getElementById("home-page") && site.screenWidth > site.breakSm) {
  //   // Get a reference to the <path>
  //   let dottedMaskPath = document.getElementById("dotted-mask-path");
  //   // console.log('dottedMaskPath', dottedMaskPath);

  //   // Get length of path... which DOES NOT depend on page length
  //   let dottedMaskPathLength = dottedMaskPath.getTotalLength();
  //   // console.log('dottedMaskPathLength', dottedMaskPathLength);

  //   // Make very long dashes and gaps between (the length of the path itself)
  //   dottedMaskPath.style.strokeDasharray = dottedMaskPathLength + " " + dottedMaskPathLength; // dash and gap length is same

  //   // Offset the dashes so the it appears hidden entirely
  //   dottedMaskPath.style.strokeDashoffset = dottedMaskPathLength;

  //   // passive scrolling for better UI, from https://www.javascripttutorial.net/javascript-dom/javascript-scroll-events/
  //   let scrollThreshold = 5;

  //   // dont count top banner in progress down page
  //   let bannerOffset = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.documentElement.clientHeight) / 5;
  //   // console.log('bannerOffset', bannerOffset);

  //   // get help with line calculation
  //   let dottedPathHeight = document.getElementById("dotted-line-svg").clientHeight;
  //   // console.log('dottedPathHeight', dottedPathHeight);
  //   let pxToLengthRatio = dottedMaskPathLength / dottedPathHeight;
  //   // console.log('pxToLengthRatio', pxToLengthRatio);

  //   // get topper offset
  //   let headerHeight = document.querySelector("header").clientHeight;
  //   let bannerHeight = document.getElementById("navbar-js").clientHeight;
  //   let topperHeight = headerHeight + bannerHeight;
  //   // console.log('topperHeight', topperHeight);

  //   document.addEventListener(
  //     "scroll",
  //     function (e) {
  //       // first close nav if its open

  //       // // console.log('window.pageYOffset', window.pageYOffset);
  //       // // close body if far away from when most recently clicked to open nav
  //       // // otherwise will close too quick
  //       // if(window.pageYOffset < site.openNavOffset - scrollThreshold ||
  //       //   window.pageYOffset > site.openNavOffset + scrollThreshold) {
  //       //   document.body.classList.remove('menu-is-open');
  //       // }

  //       // What % down is it?
  //       // https://stackoverflow.com/questions/2387136/cross-browser-method-to-determine-vertical-scroll-percentage-in-javascript/2387222#2387222
  //       // Had to try three or four differnet methods here. Kind of a cross-browser nightmare.
  //       let scrollPercentage = (document.documentElement.scrollTop + document.body.scrollTop) / (document.documentElement.scrollHeight - document.documentElement.clientHeight);
  //       // console.log('scrollPercentage', (scrollPercentage * 100).toFixed(0) + '%');
  //       // let scrollPercentage = 0.4;

  //       /*
  //        * new way of calculating progress
  //        */
  //       // let viewportToTop = document.documentElement.scrollTop;
  //       // let halfViewport = window.innerHeight / 2;
  //       // let pageHeight = document.body.clientHeight;
  //       // console.log('pageHeight', pageHeight);
  //       // let easyPercentage = (((viewportToTop + halfViewport) / pageHeight) * 100).toFixed(0) + '%';
  //       // console.log('easyPercentage', easyPercentage);

  //       /*
  //        * how far down should we unmask line?
  //        */
  //       let viewportToTop = document.documentElement.scrollTop;
  //       let halfViewport = window.innerHeight / 2;
  //       let centerScreenToTop = viewportToTop + halfViewport;
  //       // console.log('centerScreenToTop', centerScreenToTop);

  //       // set offset, according to spec, to start mask this far along its own length,
  //       // which would leave totalLength - offset to reveal path beneath
  //       // but path is wayward and doesn't go straight down page, so have to guess how much
  //       // of the zigzag line should be shown

  //       // calculate ratio of px height to length of line
  //       let pathDistanceTravelled = centerScreenToTop;

  //       // set offset
  //       let maskOffset = dottedMaskPathLength - centerScreenToTop * pxToLengthRatio + topperHeight * pxToLengthRatio;

  //       // have to speed up drawing so not 1:1 with scroll position b/c line is very wavy
  //       let speedFactor = 0.4;
  //       speedFactor = 0.2;

  //       // Draw in reverse
  //       dottedMaskPath.style.strokeDashoffset = 11600;
  //       dottedMaskPath.style.strokeDashoffset = 12000;
  //       dottedMaskPath.style.strokeDashoffset = 13000;
  //       dottedMaskPath.style.strokeDashoffset = 14000;
  //       dottedMaskPath.style.strokeDashoffset = 14250;
  //       dottedMaskPath.style.strokeDashoffset = 15000;
  //       dottedMaskPath.style.strokeDashoffset = 15250;
  //       dottedMaskPath.style.strokeDashoffset = 15598;
  //       dottedMaskPath.style.strokeDashoffset = 11000;
  //       dottedMaskPath.style.strokeDashoffset = 0;
  //       dottedMaskPath.style.strokeDashoffset = maskOffset;
  //     },
  //     {passive: true}
  //   );
  // }

  /******
   * Hub Category Filtering
   *****/
  /*
   * classes filter
   */
  let mixer;
  if (document.getElementById("hub-filter-list")) {
    mixer = mixitup("#hub-filter-list", {
      multifilter: {
        enable: true, // enable the multifilter extension for the mixer
      },
      selectors: {
        target: ".hub-item",
      },
      animation: {
        enable: false,
      },
      callbacks: {
        onMixStart: function (state, futureState) {
          // console.log(futureState.activeFilter.selector);
        },
      },
    });
  }

  /******
   * AD Club Connector Filtering
   *****/
  /*
   * freelance filter
   */
  let freelancersList = document.querySelector(".freelancers-section .popdown-list");
  if (freelancersList) {
    mixer = mixitup(freelancersList, {
      multifilter: {
        enable: true, // enable the multifilter extension for the mixer
      },
      selectors: {
        target: ".person-item",
      },
      animation: {
        enable: false,
      },
      callbacks: {
        onMixStart: function (state, futureState) {
          // close detail dropdown if open
          let freelanceClose = document.querySelector(".person-dropdown-close-wrapper");
          if (freelanceClose) {
            closeInfo(this);
          }
        },
        onMixEnd: function (state) {
          // reset row counts so detail dropdown goes to right row
          setRows();
        },
      },
    });

    // set row dataset for each visible freelancer so popdown ends up in correct row
    setRows();
  }

  /******
   * Set Rows
   * gets fully hoisted to top at runtime, from https://stackoverflow.com/a/336868/4504073
   * sets css row number if mobile or desktop or after filter
   *****/
  function setRows() {
    let freelancersList = document.querySelector(".freelancers-section .popdown-list");
    if (freelancersList) {
      let freelancers = freelancersList.children;
      let visibleFreelancers = [];

      // figure out how many freelancers are currently visible
      for (let i = 0; i < freelancers.length; i++) {
        let freelancer = freelancers[i];
        if (freelancer.checkVisibility()) {
          visibleFreelancers.push(freelancer); // inc
        }
      }

      // give each freelancer a new row number based on where they currently lie
      visibleFreelancers.forEach(function (freelancer, i) {
        // if on desktop
        if (site.isMedium.matches) {
          freelancer.dataset.row = Math.floor(i / 4) + 1; // divide by four and drop remainder, add 1 since 0 based from for loop above
          // if on mobile
        } else {
          freelancer.dataset.row = Math.floor(i / 2) + 1; // divide by four and drop remainder, add 1 since 0 based from for loop above
        }
      });
    }
  }

  /******
   * AD Club Connector Search
   *****/
  if (document.getElementById("connector-page")) {
    // get list of freelancers
    let list = [];
    let freelancers = document.querySelectorAll(".person-item");
    let i = 0;
    freelancers.forEach(function (elem) {
      let freelancerName = elem.querySelector(".person-name").innerHTML;
      list.push({
        name: freelancerName,
        index: i,
      });
      // console.log(freelancerName);

      i++;
    });
    // console.log('list', list);

    const options = {
      includeScore: true,
      threshold: 0.2, // 1 in 5 can be off
      keys: ["name"],
    };

    const fuse = new Fuse(list, options);
    // const result = fuse.search('frz');

    // console.log('result', result);
    // get search formluke hatfie loc

    // use input, from https://stackoverflow.com/a/10911096/4504073
    let searchForm = document.getElementById("search-form");
    if (searchForm) {
      let searchField = document.getElementById("search-field");
      // searchForm.addEventListener('keydown', delay(function (event) {
      searchForm.addEventListener("keyup", function (event) {
        // reset filter
        // document.querySelector('.filter-clear').click();

        let searchTerm = searchField.value;
        // get searchterm
        // let searchTerm = this.

        // step 1. get search json from route
        // searchThis(searchTerm);
        // console.log('searching...');

        const result = fuse.search(searchTerm);
        // console.log('result', result);

        // hide view all button
        // $projectsWrapper.removeClass('limited-height');

        // hide all projects

        // hold all results
        let resultClasses = "";

        // only show artists that match results
        for (i = 0; i < result.length; i++) {
          // let indextohide = result[i].item.index;
          // console.log('indextohide', indextohide);
          let name = result[i].item.name;
          // convert spaces to dashes and make lower
          let nameSlug = name.replace(/\s+/g, "-").toLowerCase(); // slugify
          // convert right single quotation mark to dashes
          nameSlug = nameSlug.replace(/\’/g, "-");
          // convert foot mark/apostrophe to dashes
          nameSlug = nameSlug.replace(/\'/g, "-");
          // get rid of periods
          nameSlug = nameSlug.replace(/\./g, "");

          // console.log('nameSlug', nameSlug);

          if (i == 0) {
            resultClasses += "." + nameSlug;
          } else {
            resultClasses += ", ." + nameSlug;
          }

          // show item
          // freelancers[indextohide].style.display = "block";
          // console.log("index", index);
          //
        }

        console.log("resultClasses", resultClasses);

        // reset no search results
        if (searchTerm != "") {
          // show results
          mixer.filter(resultClasses);
        } else {
          mixer.show();
        }

        // freelancers.forEach(function(elem) {
        //
        // });
      });

      // clear filters also clears search field
      let filterClear = document.querySelector(".filter-clear");
      filterClear.addEventListener("click", function () {
        // clear search too
        searchField.value = "";
      });
    }
  }

  /*****
   * open login from sidebar button on freelancer portal
   *****/
  let freelancerButton = document.getElementById("freelancer-button");
  if (freelancerButton) {
    freelancerButton.addEventListener("click", function () {
      let popoverBox = document.getElementById("popover-box");
      popoverBox.classList.add("show-person", "show-member-login");
      document.body.classList.add("hub-popover-open");

      // focus on email input
      let emailInput = document.querySelector("input#email");
      emailInput.focus();
    });
  }
});
